/* eslint-disable indent */
import config from '@bingads-webui-component-legacy/config/index';
import { withDFMCache } from '@bingads-webui/dfm-cache';
import { edmCampaign } from '@bingads-webui/edm-campaign';

import { formatDate } from './util';

export const locationGranularity = {
  country: {
    name: 'CountryName',
    longitude: 'CountryLongitude',
    latitude: 'CountryLatitude',
  },
  county: {
    name: 'CountyName',
    longitude: 'CountyLongitude',
    latitude: 'CountyLatitude',
  },
  stateOrProvince: {
    name: 'StateOrProvince',
    longitude: 'SubGeographyLongitude',
    latitude: 'SubGeographyLatitude',
  },
  city: {
    name: 'City',
    longitude: 'CityLongitude',
    latitude: 'CityLatitude',
  },
  postalCode: {
    name: 'PostalCode',
    longitude: 'PostalCodeLongitude',
    latitude: 'PostalCodeLatitude',
  },
};

function mapMetric(metric) {
  let mappedMetric = metric;

  switch (metric) {
    case 'TopImpressionRate':
      mappedMetric = 'TopImpressionRatePercent';
      break;
    case 'AbsoluteTopImpressionRate':
      mappedMetric = 'AbsoluteTopImpressionRatePercent';
      break;
    default:
      break;
  }
  return mappedMetric;
}

function fetch({
  cid, aid, campaignId, dateRange, metric, level,
}) {
  return edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)['Default.DimensionReport']
    .$makeCall({
      functionParams: {
        Locale: config.get('CultureLcid'),
        ReportType: 'Enum.DimensionReportType\'Geographic\'',
      },
      query: {
        count: true,
        skip: 0,
        top: 15,
        orderby: {
          [mapMetric(metric)]: '-1',
        },
        select: [level.name, level.longitude, level.latitude, metric],
        startDate: formatDate(dateRange.start),
        endDate: formatDate(dateRange.end),
      },
    })
    .toPromise();
}

export const fetchCountryData = withDFMCache(({
  cid, aid, campaignId, dateRange, metric,
}) => fetch({
  cid,
  aid,
  campaignId,
  dateRange,
  metric,
  level: locationGranularity.country,
}), 'CardType-TopLocations-country-data');

export const fetchStateOrProvinceData = withDFMCache(({
  cid, aid, campaignId, dateRange, metric,
}) => fetch({
  cid,
  aid,
  campaignId,
  dateRange,
  metric,
  level: locationGranularity.stateOrProvince,
}), 'CardType-TopLocations-state-or-province-data');

export const fetchCountyData = withDFMCache(({
  cid, aid, campaignId, dateRange, metric,
}) => fetch({
  cid,
  aid,
  campaignId,
  dateRange,
  metric,
  level: locationGranularity.county,
}), 'CardType-TopLocations-county-data');

export const fetchCityData = withDFMCache(({
  cid, aid, campaignId, dateRange, metric,
}) => fetch({
  cid,
  aid,
  campaignId,
  dateRange,
  metric,
  level: locationGranularity.city,
}), 'CardType-TopLocations-city-data');

export const fetchPostalCodeData = withDFMCache(({
  cid, aid, campaignId, dateRange, metric,
}) => fetch({
  cid,
  aid,
  campaignId,
  dateRange,
  metric,
  level: locationGranularity.postalCode,
}), 'CardType-TopLocations-postal-code-data');
